import { usersRoutes } from '../routes'
import { ROLES } from '../config/Constants'

export default async (level) => {
    return new Promise((resolve) => {
        const fetchIds = async () => {
            const admin = await usersRoutes.findByRole(ROLES.ADMIN)
            const data = await usersRoutes.findByRole(ROLES.SAP_EXECUTIVE)
            const data1 = await usersRoutes.findByRole(ROLES.SHIFT_MANAGER)
            const data2 = await usersRoutes.findByRole(ROLES.CHIEF_MACHINERY)
            const admins = admin.data
            const sapExecutives = data.data
            const chiefMachineries = data1.data
            const shiftManagers = data2.data
            const ids = []
            admins.forEach((admin, index) => {
                ids.push(admin._id)
                if (index === (admins.length - 1)) {
                    sapExecutives.forEach((user, i) => {
                        ids.push(user._id)
                        if (i === (sapExecutives.length - 1)) {
                            if (level === 1) {
                                chiefMachineries.forEach((u, n) => {
                                    ids.push(u._id)
                                    if (n === (chiefMachineries.length - 1)) {
                                        shiftManagers.forEach((s, x) => {
                                            ids.push(s._id)
                                        })
                                        if (n === (shiftManagers.length - 1)) {
                                            resolve(ids)
                                        }
                                    }
                                })
                            } else if (level === 2) {
                                chiefMachineries.forEach((u, n) => {
                                    ids.push(u._id)
                                    if (n === (chiefMachineries.length - 1)) {
                                        resolve(ids)
                                    }
                                })
                            } else if ((level === 3) || (level === 4)) {
                                resolve(ids)
                            } else {
                                resolve(ids)
                            }
                        }
                    })
                }
            })
        }
        fetchIds()
    })
}
